<button class="close modalClose" mat-button (click)="onNoClick()" tabindex="-1">
  X
</button>
<h3 mat-dialog-title>Configure Filter</h3>
<p class="fieldName">Field: {{ name }}</p>
<div mat-dialog-content [formGroup]="editForm" class="form">
  <div *ngFor="let field of formFields" id="{{ field.name }}">
    <ng-container *ngIf="field.displayType == 'select'">
      <ng-container *ngIf="field.showField">
        <label>{{ field.label }}:</label>
        <!-- For SELECT type of fields (single)-->
        <mat-form-field appearance="fill" style="width: 70%">
          <mat-select
            [formControlName]="field.name"
            placeholder="Please select an option"
            floatPlaceholder="never"
            required="true"
            (selectionChange)="modifyConfigValues($event, field.name)"
          >
            <mat-option
              *ngFor="let item of field.options.data"
              [value]="item.value"
              [disabled]="item.disabled"
            >
              {{ item.text }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <!-- end SELECT-->
      </ng-container>
    </ng-container>

    <ng-container *ngIf="field.displayType == 'multiSelect'">
      <ng-container *ngIf="field.showField">
        <label>{{ field.label }}:</label>
        <!-- For SELECT type of fields (multiple)-->
        <ng-select
          [items]="field.options.data"
          class="custom"
          [appendTo]="'body'"
          [formControlName]="field.name"
          [closeOnSelect]="false"
          placeholder="Please select an option"
          floatPlaceholder="never"
          required="true"
          [multiple]="true"
          (selectionChange)="modifyConfigValues($event, field.name)"
          bindLabel="text"
          bindValue="value"
          [hideSelected]="true"
        >
        </ng-select>
        <!-- end SELECT-->
      </ng-container>
    </ng-container>

    <ng-container
      *ngIf="field.displayType == 'text' || field.displayType == 'number'"
    >
      <ng-container *ngIf="field.showField">
        <label>{{ field.label }}:</label>
        <!-- For TEXT & NUMBER type of fields-->
        <mat-form-field appearance="fill" style="width: 70%">
          <input
            matInput
            [formControlName]="field.name"
            name="{{ field.name }}"
            placeholder="{{ field.placeholder || '' }}"
            type="{{ field.displayType }}"
            required="true"
          />
        </mat-form-field>
        <!-- end TEXT & NUMBER -->
      </ng-container>
    </ng-container>

    <ng-container *ngIf="field.displayType == 'textarea'">
      <ng-container *ngIf="field.showField">
        <label>{{ field.label }}:</label>
        <!-- For TEXTFIELD type of fields-->
        <mat-form-field appearance="fill" style="width: 70%">
          <textarea
            matInput
            [formControlName]="field.name"
            name="{{ field.name }}"
            placeholder="{{ field.title }}"
            type="{{ field.displayType }}"
            required="true"
          ></textarea>
        </mat-form-field>
        <!-- end TEXTFIELD-->
      </ng-container>
    </ng-container>

    <ng-container *ngIf="field.displayType == 'datepicker'">
      <ng-container *ngIf="field.showField">
        <label>{{ field.label }}:</label>
        <!-- For DATE (text) type of fields-->
        <mat-form-field appearance="fill" style="width: 70%" class="date">
          <input
            matInput
            readonly
            [matDatepicker]="picker"
            (click)="picker.open()"
            [formControlName]="field.name"
            name="{{ field.name }}"
            required="true"
            placeholder="Select a Date"
          />
          <mat-datepicker-toggle
            matSuffix
            [for]="picker"
          ></mat-datepicker-toggle>
          <mat-datepicker #picker></mat-datepicker>
        </mat-form-field>
        <!-- end DATE-->
      </ng-container>
    </ng-container>

    <ng-container *ngIf="field.displayType == 'daterange'">
      <ng-container *ngIf="field.showField">
        <label>{{ field.label }}:</label>
        <!-- For DATERANGE  type of fields-->

        <mat-form-field appearance="fill" style="width: 70%" class="date">
          <mat-date-range-input
            [formGroupName]="field.name"
            [rangePicker]="picker"
            required="true"
          >
            <input
              matStartDate
              formControlName="start"
              placeholder="Start date"
              required="true"
            />
            <input
              matEndDate
              formControlName="end"
              placeholder="End date"
              [required]="field.isRequired"
            />
          </mat-date-range-input>
          <mat-datepicker-toggle
            matSuffix
            [for]="picker"
          ></mat-datepicker-toggle>
          <mat-date-range-picker #picker></mat-date-range-picker>
        </mat-form-field>
        <!-- end DATERANGE -->
      </ng-container>
    </ng-container>

    <ng-container
      *ngIf="
        field.displayType == 'button-toggle' ||
        field.displayType == 'toggle' ||
        field.displayType == 'checkbox'
      "
      appearance="legacy"
    >
      <ng-container *ngIf="field.showField">
        <label>{{ field.label }}:</label>
        <!-- For TOGGLE type of fields-->
        <div
          [formGroupName]="field.name"
          style="width: 70%; display: inline-block"
        >
          <mat-button-toggle-group
            #group="matButtonToggleGroup"
            [multiple]="field.multiple"
            formControlName="item"
            required="true"
          >
            <mat-button-toggle
              *ngFor="let toggle of field.options.data"
              mat-raised-button
              [value]="toggle.value"
              >{{ toggle.text }}</mat-button-toggle
            >
          </mat-button-toggle-group>
        </div>
        <!-- end TOGGLE-->
      </ng-container>
    </ng-container>
  </div>
</div>
<div mat-dialog-actions align="end">
  <button mat-button mat-dialog-close class="button_small cancel" *ngIf="!auto">
    cancel
  </button>
  <button
    *ngIf="auto"
    mat-button
    class="button_small cancel"
    (click)="onCancelClick()"
    style="width: 130px"
  >
    cancel & remove
  </button>
  <button mat-button class="button_small" (click)="onConfirmClick()">
    apply
  </button>
</div>
